import cs from 'classnames';
import React from 'react';
import { MutationErrorArray } from 'shared/utils/mutations';

interface Props {
  errors: MutationErrorArray
}

export const SummaryValidationErrors = (props: Props) => (
  <div className="alert alert-danger">
    <p className={cs("alert-heading", props.errors.length === 0 && "mb-0")}>There are some issues that need fixing before submitting your application.</p>
    {props.errors.map((error, index) => error && (
      <div><b>{error.field}:</b> {error.messages.map(msg => <>{msg}<br/></>)}</div>
    ))}
  </div>
);
